import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';

import { LoadingWrapper } from 'components/Loading';
import squareboardDrawingContact from 'assets/images/contact.svg';

import ContactForm from './ContactForm';

class ContactView extends Component {
  static propTypes = {
    destroy: PropTypes.func.isRequired,
    sendContactRequest: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const footerHeight = document.getElementById('footer').clientHeight;
    const headerHeight = document.getElementById('header').clientHeight;

    this.setState({ footerHeight, headerHeight });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    return (
      <div
        className="container"
        style={{
          minHeight: `calc(100vh - (${this.state.headerHeight}px + ${this.state.footerHeight}px))`,
        }}
      >
        <div className="contact-illustration u-flex">
          <div className="u-max-size u-flex u-flex-align-items">
            <img src={squareboardDrawingContact} alt="" className="u-max-size" />
          </div>
        </div>

        <div className="contact-form u-flex u-flex-align-items u-flex-column u-self-center">
          {this.state.contactSent && (
            <div className="u-flex u-flex-row u-max-size alert u-mb-2">
              <ZapIcon icon="mailers--lines" className="u-mr-2" />
              {this.props.translations['contact.messageSent']}
            </div>
          )}
          <LoadingWrapper loaders={['SEND_CONTACT_REQUEST']} loadingView="SPINNER">
            <ContactForm
              key="contactForm"
              {...this.props}
              onSubmit={(values) => {
                this.props.sendContactRequest(
                  { values },
                  {
                    loading: true,
                    callbackSuccess: () => {
                      this.props.destroy('contactForm');
                      this.setState({ contactSent: true }, () => {
                        this.timeout = setTimeout(() => {
                          this.setState({ contactSent: false });
                        }, 10000);
                      });
                    },
                  },
                );
              }}
            />
          </LoadingWrapper>
        </div>
      </div>
    );
  }
}

export default ContactView;
